const storeAuthToken = (value) => {
  localStorage.setItem('authtoken', value)
}
const storeEmailID = (value) => {
  localStorage.setItem('emailID', value)
}
const storeUserID = (value) => {
  localStorage.setItem('userID', value)
}
const storeUserType = (value) => {
  localStorage.setItem('usertype', value)
}
const storeUserName = (value) => {
  localStorage.setItem('username', value)
}
const storeHomeLogo = (value) => {
  localStorage.setItem('homelogo', value)
}
const storeLoginLogo = (value) => {
  localStorage.setItem('loginlogo', value)
}
const storeFavicon = (value) => {
  localStorage.setItem('favicon', value)
}
const storeDomainImageUrls = (value) => {
  localStorage.setItem('domain_image_urls', value)
}

const getAuthToken = () => {
  return localStorage.getItem('authtoken')
}
const getEmailID = () => {
  return localStorage.getItem('emailID')
}
const getUserID = () => {
  return localStorage.getItem('userID')
}
const getUserType = () => {
  return localStorage.getItem('usertype')
}
const getUserName = () => {
  return localStorage.getItem('username')
}
const getHomeLogo = () => {
  return localStorage.getItem('homelogo')
}
const getLoginLogo = () => {
  return localStorage.getItem('loginlogo')
}
const getFavicon = () => {
  return localStorage.getItem('favicon')
}
const getDomainImageUrls = () => {
  return localStorage.getItem('domain_image_urls')
}

const removeAuthToken = () => {
  localStorage.removeItem('authtoken')
  localStorage.removeItem('emailID')
  localStorage.removeItem('userID')
  localStorage.removeItem('usertype')
  localStorage.removeItem('username')
  localStorage.removeItem('domain_image_urls')
}

export {
  storeAuthToken,
  getAuthToken,
  removeAuthToken,
  storeUserType,
  getUserType,
  storeUserID,
  storeEmailID,
  getUserID,
  getEmailID,
  storeUserName,
  getUserName,
  storeFavicon,
  storeLoginLogo,
  storeHomeLogo,
  getFavicon,
  getLoginLogo,
  getHomeLogo,
  storeDomainImageUrls,
  getDomainImageUrls
}
